export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_ACCOUNTS = 'SET_ACCOUNTS';
export const SET_ISRECONNECTING = 'SET_ISRECONNECTING';
